import { t } from '@lingui/core/macro';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { Products } from 'components/Products/Products';

export const ProductsPage = () => {
  return (
    <BaseLayout showDEFooter pageTitle={t`Products | Introducer Portal`}>
      <Products />
    </BaseLayout>
  );
};
